import enLang from './entries/en-US';
import saLang from './entries/es-ES';

const AppLocale = {
  en: enLang,
  es: saLang,
};

export default AppLocale;
